import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/e87bcf04e7625c18d803186005e49f89/d3b85133aa0f2052ce6d4a05a6d7dbde.png"
              alt="Vertak Group"
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              A diversified Indian business group delivering excellence in infrastructure, mining, gems & jewellery, and corporate services.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" onClick={(e) => scrollToSection(e, '#about')} className="text-gray-400 hover:text-[#C9A961] text-sm transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" onClick={(e) => scrollToSection(e, '#services')} className="text-gray-400 hover:text-[#C9A961] text-sm transition-colors cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="#projects" onClick={(e) => scrollToSection(e, '#projects')} className="text-gray-400 hover:text-[#C9A961] text-sm transition-colors cursor-pointer">
                  Projects
                </a>
              </li>
              <li>
                <Link to="/clients" className="text-gray-400 hover:text-[#C9A961] text-sm transition-colors">
                  Clients
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">Infrastructure Development</li>
              <li className="text-gray-400 text-sm">Construction Services</li>
              <li className="text-gray-400 text-sm">Mining & Minerals</li>
              <li className="text-gray-400 text-sm">Gems & Jewellery</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-400 text-sm">
                <i className="ri-map-pin-line text-[#C9A961] mr-2 mt-1"></i>
                <span>Jaipur, Rajasthan, India</span>
              </li>
              <li className="flex items-start text-gray-400 text-sm">
                <i className="ri-mail-line text-[#C9A961] mr-2 mt-1"></i>
                <a href="mailto:info@vertakgroup.com" className="hover:text-[#C9A961] transition-colors">
                  info@vertakgroup.com
                </a>
              </li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-[#C9A961] rounded-lg flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-[#C9A961] rounded-lg flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-[#C9A961] rounded-lg flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2026 Vertak Group. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-gray-400 hover:text-[#C9A961] text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C9A961] text-sm transition-colors">
                Terms
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#C9A961] text-sm transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}